import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 48px 0;
  width: 100%;
`;
